import { axios } from '@/Services/Backend';
import { buildQueryObjectFromModel } from './QueryBuilder';
import moment from 'moment';

export default {
    props: {
        endpoint: String,

        queryParams: {
            type: Object,
        },

        ready: {
            type: Boolean,
            default: true,
        },

        customSearch: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },

    data: () => ({
        isLoading: false,
        localEndpoint: null,
        previousFilters: {},
        paginator: {},
        localOptions: {},
        queryObject: {},
        currentOperator: 'all',
        timer: null,
    }),

    computed: {
        footerProps() {
            return {
                itemsPerPageOptions: window.innerWidth <= 1024?[20,50,80 ]: [10, 20, 50],
                disableItemsPerPage: this.isLoading,
                disablePagination: this.isLoading,
            };
        },
        vBind() {
            return {
                loading: this.isLoading,
                items: this.paginator.data,
                page: this.paginator.meta?.current_page,
                'server-items-length': this.paginator.meta?.total,
                'disable-filtering': this.isLoading,
                'disable-pagination': this.isLoading,
                'disable-sort': this.isLoading,
                'footer-props': this.footerProps,
            };
        },
        vOn() {
            return {
                //
            };
        },
    },

    created() {
        this.localEndpoint = this.endpoint;
    },

    methods: {
        getItems() {
            this.isLoading = true;

            if (!this.ready) {
                return;
            }

            axios
                .post(this.localEndpoint, {
                    ...this.localOptions,
                    ...this.queryParams,
                    queryObject: JSON.stringify(this.queryObject),
                })
                .then((response) => {
                    this.isLoading = false;
                    this.paginator = response.data;

                    this.$emit('data-changed', this.paginator);
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        changeEndpoint(endpoint) {
            this.localEndpoint = endpoint;
        },
        setCurrentOperator(operator) {
            this.currentOperator = operator;
        },
        onUpdateOptions(options) {
            this.setLocalOptions(options);
            this.getItems();
        },
        setLocalOptions(options) {
            // @Note: When we change the number of items per page, we'll want to reset the pagination -
            //         just in case the user is on a later page and is not seeing any results.
            if (this.localOptions?.itemsPerPage && this.localOptions?.itemsPerPage !== options?.itemsPerPage) {
                options.page = 1;
            }
            //if(window.innerWidth<=1024 &&  options.itemsPerPage==10){
              //  options.itemsPerPage=20;
            //}

            this.localOptions = options;
        },
        isQueryObject(obj) {
            return Object.keys(obj).includes('logicalOperator') && Object.keys(obj).includes('children');
        },
        applyQueryObject(filters, schema) {
            // If it's an advanced filter - use it, otherwise we need to convert the filters into an advanced query.
            this.queryObject = this.isQueryObject(filters)
                ? filters //
                : buildQueryObjectFromModel(filters, schema, { customSearch: this.customSearch, operator: this.currentOperator });

            // @Note: When we change a filter, we want to reset the pagination.
            if (JSON.stringify(this.queryObject) !== JSON.stringify(this.previousFilters)) {
                this.$set(this.localOptions, 'page', 1);
            }
            this.previousFilters = this.queryObject;

            this.getItems();
        },

        onChangeQueryBuilder(filters, schema) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }

            this.timer = setTimeout(() => {
                this.applyQueryObject(filters, schema);
            }, 500);
        },

        exportData(axiosSettings, fileName) {
            axiosSettings.params = {
                ...axiosSettings.params,
                ...this.localOptions,
                ...this.queryParams,
                queryObject: JSON.stringify(this.queryObject),
            };

            window?.EventBus?.$emit('export-started');

            axios
                .post(
                    axiosSettings.url,
                    {
                        ...axiosSettings.params,
                        ...this.localOptions,
                        ...this.queryParams,
                        queryObject: JSON.stringify(this.queryObject),
                    },
                    {
                        responseType: 'blob',
                    }
                )
                .then((res) => {
                    const fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    const fileLink = document.createElement('a');

                    fileLink.href = fileURL;

                    const date = moment().format('YYYY-M-D_HH:mm:ss');
                    fileLink.setAttribute('download', `${fileName}-${date}.xlsx`);
                    document.body.appendChild(fileLink);

                    fileLink.click();

                    window?.EventBus?.$emit('export-finished');
                })
                .catch(() => {
                    window?.EventBus?.$emit('export-failed');
                });
        },
    },

    render() {
        return this.$scopedSlots.default({
            isLoading: this.isLoading,
            footerProps: this.footerProps,
            paginator: this.paginator,
            getItems: this.getItems,
            changeEndpoint: this.changeEndpoint,
            vOn: this.vOn,
            vBind: this.vBind,
            updateFilters: this.updateFilters,
            updateOptions: this.onUpdateOptions,
            setLocalOptions: this.setLocalOptions,
            applyQueryObject: this.applyQueryObject,
            onChangeQueryBuilder: this.onChangeQueryBuilder,
            setCurrentOperator: this.setCurrentOperator,
        });
    },
};
